import StoreTransactionsTeacher from "components/module/storeTransactionsTeacher"

const ClassStoreTeacherPage = () => {
  return <StoreTransactionsTeacher />
}

export default ClassStoreTeacherPage
